import {
    Button,
    FormControl,
    InputLabel,
    TextField,
    Typography,
    makeStyles,
} from '@material-ui/core';
import React from 'react';
import { ERROR_MESSAGES } from '../../app/constants';
import { MenuItem, Select } from '@mui/material';
import PhoneInput from 'react-phone-input-2';

const useStyles = makeStyles((theme) => ({
    form: {
        maxWidth: '350px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '10px',
    },
    input: {
        marginTop: 24,
    },
    submitBtn: {
        display: 'flex',
        justifyContent: 'center',
    },
    phoneInput: {
        width: '100% !important',
        padding: '18.5px 14px 18.5px 58px',
    },
    pageWrapper: {
        padding: '10px',
    },
}));

export default function StoreForm({
    handleSubmit,
    register,
    setPhoneNumber,
    setOtherErrorsMsg,
    errorMessage,
    phoneNumber,
    isEdit = false,
    creditAccountsValue = null
}) {
    const classes = useStyles();

    return (
        <form onSubmit={handleSubmit} className={classes.form}>
            <FormControl margin="dense">
                <InputLabel shrink={true} variant="filled">
                    Store name
                </InputLabel>
                <TextField
                    variant="outlined"
                    className={classes.input}
                    {...register('name', {
                        required: ERROR_MESSAGES.STORE_NAME,
                    })}
                />
            </FormControl>

            <FormControl margin="dense">
                <InputLabel shrink={true} variant="filled">
                    UIC
                </InputLabel>
                <TextField
                    variant="outlined"
                    className={classes.input}
                    {...register('uic', { required: ERROR_MESSAGES.UIC })}
                />
            </FormControl>

            <FormControl margin="dense">
                <InputLabel shrink={true} variant="filled">
                    URL
                </InputLabel>
                <TextField
                    variant="outlined"
                    className={classes.input}
                    {...register('url', { required: ERROR_MESSAGES.URL })}
                />
            </FormControl>

            {!isEdit && (
                <FormControl margin="dense">
                    <InputLabel shrink={true} variant="filled">
                        Security token
                    </InputLabel>
                    <TextField
                        variant="outlined"
                        className={classes.input}
                        {...register('securityToken', {
                            required: ERROR_MESSAGES.SECURITY_TOKEN,
                        })}
                    />
                </FormControl>
            )}
            <FormControl margin="dense">
                <InputLabel shrink={true} variant="filled">
                    Contact name
                </InputLabel>
                <TextField
                    variant="outlined"
                    className={classes.input}
                    {...register('contactPerson', {
                        required: ERROR_MESSAGES.CONTACT_PERSON,
                    })}
                />
            </FormControl>
            <InputLabel shrink={true} variant="filled">
                Credit accounts
            </InputLabel>
            <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                // value={age}
                label="Age"
                // onChange={handleChange}
                {...register('creditAccounts')}
                defaultValue={creditAccountsValue !== null ? creditAccountsValue : true}
            >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
            </Select>
            <InputLabel shrink={true} variant="filled">
                Phone number
            </InputLabel>
            <PhoneInput
                country={'gb'}
                autoFormat={true}
                specialLabel=""
                inputClass={classes.phoneInput}
                onChange={(value) => {
                    setPhoneNumber(value);
                    setOtherErrorsMsg('');
                }}
                value={phoneNumber}
            />
            <InputLabel className="phone-label" shrink={true} variant="filled">
                Phone number should start with a country code, e.g.+44
            </InputLabel>
            <Typography color="primary" align="center">
                {errorMessage}
            </Typography>

            <div className={classes.submitBtn}>
                <Button type="submit" variant="contained" color="primary">
                    submit
                </Button>
            </div>
        </form>
    );
}
